module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-gift-802eab26ee93b93d06f5bbdfa4e589ab.svg";